





































import Vue from "vue";
import { GridRow, GridData } from "./GridView.vue";
import chunk from "lodash-es/chunk";
import find from "lodash-es/find";
import get from "lodash-es/get";
import isEmpty from "lodash-es/isEmpty";

interface RowDataGridChunkedRow {
  HeaderRow: (string | number)[];
  DataRow: (string | number)[];
}

interface RowDataGrid {
  RowId: string;
  Name: string;
  ChunkedRows: RowDataGridChunkedRow[];
}

export default Vue.extend({
  data() {
    return {
      chunksize: 3, //cols=4
      selectedRowId: null as null | string
    };
  },

  props: {
    columnTotalindex: {
      type: Number,
      required: false,
      default: 0
    },
    columnHeaders: {
      type: Object,
      required: true,
      default: () => {
        return {
          Fields: [
            "column 1",
            "column 2",
            "column 3",
            "column 4",
            "column 5",
            "column 6"
          ]
        } as GridRow;
      }
    },
    gridData: {
      type: Object,
      required: true,
      default: () => {
        return {
          Rows: [{ RowId: "Id1", Fields: [12, 32, 45, 2, 2, "34%"] } as GridRow]
        } as GridData;
      }
    }
  },
  computed: {
    chunkedGridData(): RowDataGrid[] {
      const chunckedGridData = [] as RowDataGrid[];
      const gridDataRows = get(this.gridData, "Rows", []) as GridRow[];
      if (isEmpty(gridDataRows)) return chunckedGridData;

      let splitRows = [] as GridRow[];

      splitRows = gridDataRows.map(w => {
        return {
          RowId: w.RowId,
          Fields: w.Fields.slice(1) // tail
        };
      });

      if (isEmpty(splitRows)) return chunckedGridData;

      const chunkedHeaders = chunk(
        (this.columnHeaders as GridRow).Fields.slice(1).map(title => title), //tail
        this.chunksize
      );

      let rowIdsRows = gridDataRows.map(w => {
        return {
          RowId: w.RowId,
          Fields: [w.Fields[0]] // eerste kolomn wordt titel
        };
      });

      rowIdsRows.forEach((gridRow, index) => {
        let rowData = {
          RowId: gridRow.RowId,
          Name: gridRow.Fields[0],
          ChunkedRows: []
        } as RowDataGrid;

        let dataRow = find(splitRows, row => row.RowId === gridRow.RowId);

        if (!!dataRow) {
          const chunkedData = chunk(
            (dataRow as any).Fields.map((value: number | string) => value),
            this.chunksize
          );
          chunkedHeaders.forEach((chunkedHeader, chunkedIndex) => {
            const chunkedRow = {
              HeaderRow: chunkedHeader,
              DataRow: chunkedData[chunkedIndex]
            } as RowDataGridChunkedRow;
            rowData.ChunkedRows.push(chunkedRow);
          });
          chunckedGridData.push(rowData);
        }
      });

      return chunckedGridData;
    }
  },
  methods: {
    rowSelectable(row: RowDataGrid): boolean {
      if (
        !isEmpty(row.ChunkedRows) &&
        row.ChunkedRows[0].DataRow[this.columnTotalindex] === 0
      ) {
        return false;
      }
      return true;
    },
    rowSelected(id: string): boolean {
      return this.selectedRowId === id;
    },
    onClicked(row: RowDataGrid) {
      if (
        !isEmpty(row.ChunkedRows) &&
        row.ChunkedRows[0].DataRow[this.columnTotalindex] === 0
      ) {
        return;
      }

      if (this.selectedRowId === row.RowId) {
        this.selectedRowId = null;
        this.$emit("row-deselected");
      } else {
        this.selectedRowId = row.RowId;
        this.$emit("row-selected", {
          IsTotalRow: false,
          Id: row.RowId
        });
      }
    }
  }
});
